
//#region

// react
import React, { useState, useEffect } from 'react';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectEmployeeList, getEmployeeList } from '_redux/slices/timeline/employees';
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";

// pigeon map
import { Map, Marker, ZoomControl } from "pigeon-maps"

// tooltips
import { ToolTippy } from '_molecules';

//#endregion

export default function Testing() {

  // redux
  const dispatch = useDispatch();
  const dbUser = useSelector(selectFirebaseInfo);

  // local states
  const [mapCenter, setMapCenter] = useState([53.41027141150944, -6.40870317033411]); // Initial map center coordinates
  const [activeStaff, setActiveStaff] = useState({});                                 // employee list with coordinates
  const [layoutVersion, setLayoutVersion] = useState(0);                              // layout version for re-rendering    
  const [hoveredEmployee, setHoveredEmployee] = useState(null);                       // state for hovered employee

  // employee list
  const employeeList = useSelector(selectEmployeeList);


  //#region side effects

  // set user location on mount
  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      const { latitude, longitude } = position.coords;
      setMapCenter([latitude, longitude]);
    }, (error) => {
      console.error("Error getting location:", error);
    });
  }, []);

  // get employeeList if empty on mount
  useEffect(() => {
    if (employeeList.length == 0) {
      dispatch(getEmployeeList(dbUser.details.authority));
    }
  }, [])

  // loop employeeList for coordinates
  useEffect(() => {
    const validEmployees = employeeList.filter(
      emp => emp.location?.coordinates?.latitude && emp.location?.coordinates?.longitude
    );

    const staffObj = validEmployees.reduce((acc, emp) => {
      acc[emp.userId] = emp;
      return acc;
    }, {});

    setActiveStaff(staffObj);
  }, [employeeList]);


  // set tooltip observer
  //#endregion

  //#region handlers
  const handleMouseOverMarker = (e) => {
    setHoveredEmployee({
      name: e.payload,
      x: e.pageX + 10,
      y: e.pageY + 10,
    });
  }

  const getEmpInitials = (name) => {
    if (!name) return 'NA';
    const parts = name.split(' ');
    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase();
    }
    return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
  }
  //#endregion

  /**
   * Testing component for displaying a map with employee markers.
   * * This component initializes a map centered on the user's location,
   * *   displays markers for employees with coordinates,
   * *   and uses ToolTippy for tooltips on markers.
   */
  return (
    <>
      <ToolTippy selectors={['[data-tippy-content]']} />

      <div className='py-5 d-flex align-items-center justify-content-center' id='mapContainerDiv' style={{ height: '97vh' }}>
        <Map defaultCenter={mapCenter} defaultZoom={18} maxZoom={22}>
          {Object.values(activeStaff).map((employee) => (
            <Marker
              anchor={[
                parseFloat(employee.location.coordinates.latitude),
                parseFloat(employee.location.coordinates.longitude)
              ]}
              onClick={handleMouseOverMarker}
              onMouseOut={() => setHoveredEmployee(null)}
              payload={employee.title}
              color='blue'
              width={70}
              height={70}
            >
              <svg width="40" height="60" viewBox="0 0 40 60">
                <defs>
                  <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
                    <feDropShadow dx="0" dy="2" stdDeviation="3" floodColor="rgba(0,0,0,0.3)" />
                  </filter>
                </defs>

                <path
                  d="M20,0
       C31,0 38,10 38,20
       C38,32 20,58 20,58
       C20,58 2,32 2,20
       C2,10 9,0 20,0
       Z"
                  fill="#3498db"
                  filter="url(#shadow)"
                />

                <text
                  x="20"
                  y="28"
                  textAnchor="middle"
                  fill="white"
                  fontWeight="bold"
                  fontSize="16"
                  fontFamily="Arial"
                  dominantBaseline="middle"
                >
                  {employee.title ? getEmpInitials(employee.title) : 'Staff'}
                </text>
              </svg>

            </Marker>
          ))}
          {/* <Marker anchor={[53.41027141150944, -6.40870317033411]}></Marker>
            <Marker anchor={[53.41027141150944, -2.40870317033411]}></Marker> */}
          <ZoomControl />
        </Map>

        {/* Simple floating tooltip */}
        {hoveredEmployee && (
          <div
            style={{
              position: 'fixed',
              bottom: 100,
              top: hoveredEmployee.y,
              left: hoveredEmployee.x,
              padding: '6px 12px',
              background: 'blue',
              color: '#fff',
              borderRadius: 6,
              fontSize: 14,
              pointerEvents: 'none',
              zIndex: 999
            }}
          >
            {hoveredEmployee.name}
          </div>
        )}
      </div>
    </>

  )
}